import { providerOrganizationsDataSelector } from "./providerOrganizationsDataSelector";
import { RootState } from "../../../store";

export const isProviderOrganisationOnlyGcpSelector = (state: RootState) => {
  const data = providerOrganizationsDataSelector(state);
  return data?.every((item) => item.cloud_provider === "gcp");
};
